import { TemplateConfig } from "../drawer/types";
import { isRuntimeFormat } from "./formatsStore";
import { FormatChannel, RuntimeFormatConfig } from "./types";

// EDDM/ADM get the address-box variant when the API has one; otherwise the blank artwork (or legacy file) applies.
export function getArtworkTemplateUrl(
  config: TemplateConfig | RuntimeFormatConfig,
  channel?: FormatChannel | null
): string {
  if (!isRuntimeFormat(config)) return config.flyerTemplate;
  const { artworkPdfEddm, artworkPdfAdm } = config.templates;
  if (channel === "EDDM" && artworkPdfEddm) return artworkPdfEddm;
  if (channel === "ADM" && artworkPdfAdm) return artworkPdfAdm;
  return config.flyerTemplate;
}
